module.exports = __webpack_public_path__ + "img/about-us.ad470b5a.jpg";